module.exports = __webpack_public_path__ + "static/favicon-29ac252205e36722dad51aa195b570b1.ico";